import { useRef, useLayoutEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Type from "./Type";
import About from "../About/About";
import Services from "../Services/Services";
import Projects from "../Projects/Projects";
import Resume from "../Resume/ResumeNew";
import Contact from "../contact/contact";
import aboutProfile from "../../Assets/Ali Bhai 02.png";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function Home() {
  const homeRef = useRef(null);
  const profileImgRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // 1️⃣ Force initial visible state
      gsap.set(profileImgRef.current, {
        rotateY: 0,
        opacity: 1,
        transformStyle: "preserve-3d",
        backfaceVisibility: "hidden",
      });

      // 2️⃣ Scroll-controlled hide and flip
      gsap.to(profileImgRef.current, {
        rotateY: 90,  // rotate sideways
        opacity: 0,   // fade out
        ease: "none",
        scrollTrigger: {
          trigger: ".home-section", // entire hero section
          start: "top top",         // animation starts immediately
          end: "bottom center",     // completes when section reaches center
          scrub: true,              // smooth scroll-based animation
          // markers: true,         // enable for debugging
        },
      });
    }, homeRef);

    return () => ctx.revert(); // cleanup on unmount
  }, []);

  return (
    <section ref={homeRef}>
      {/* HERO */}
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center">
            <Col md={7} className="home-header">
              <strong className="main-name">Muhammad Ali</strong>
              <div
                className="hero-animate"
                style={{ padding: "20px 0", fontSize: "1.5rem" }}
              >
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <div className="profile-img-container" style={{ perspective: "1200px" }}>
                <img
                  ref={profileImgRef}
                  src={aboutProfile}
                  alt="Muhammad Ali - MERN Stack Developer"
                  className="img-fluid profile-img"
                  style={{
                    maxHeight: "400px",
                    marginTop: "20px",
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* SECTIONS */}
      <section id="about" className="section-animate">
        <About />
      </section>

      <section id="services" className="section-animate">
        <Services />
      </section>

      <section id="projects" className="section-animate">
        <Projects />
      </section>

      <section id="resume" className="section-animate">
        <Resume />
      </section>

      <section id="contact" className="section-animate">
        <Contact />
      </section>
    </section>
  );
}

export default Home;
